import { render, staticRenderFns } from "./vinSubmitDialog.vue?vue&type=template&id=3a3e3b4a&scoped=true&"
import script from "./vinSubmitDialog.vue?vue&type=script&lang=ts&"
export * from "./vinSubmitDialog.vue?vue&type=script&lang=ts&"
import style0 from "./vinSubmitDialog.vue?vue&type=style&index=0&id=3a3e3b4a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a3e3b4a",
  null
  
)

export default component.exports